import ARENO_API_ENDPOINT from "../../api";
import { StatusCode } from "../../utils";

const PhysioServices = {
    getAllPhysioList: async (token, navigate) => {
        try {
            let response = await fetch(`${ARENO_API_ENDPOINT}/auth/AdminGetAllPhysioList`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    authorization: `Bearer ${token}`,
                },
                body: JSON.stringify({}),
            });

            StatusCode(response, navigate);
            response = await response.json();
            return response;
        } catch (error) {
            throw new Error(error.message);
        }
    },

    getPhysioDetails: async (token, navigate, userId) => {
        try {
            let response = await fetch(`${ARENO_API_ENDPOINT}/auth/AdminGetPhysioDetails`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    authorization: `Bearer ${token}`,
                },
                body: JSON.stringify({ UserID: userId }),
            });

            StatusCode(response, navigate);
            response = await response.json();
            return response;
        } catch (error) {
            throw new Error(error.message);
        }
    },

    updatePhysioDetails: async (token, navigate, updateData) => {
        try {
            let response = await fetch(`${ARENO_API_ENDPOINT}/auth/UpdatePhysioDetails`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    authorization: `Bearer ${token}`,
                },
                body: JSON.stringify(updateData),
            });

            StatusCode(response, navigate);
            response = await response.json();
            return response;
        } catch (error) {
            throw new Error(error.message);
        }
    },

    assignCreditsToPhysio: async (token, navigate, creditsData) => {
        try {
            let response = await fetch(`${ARENO_API_ENDPOINT}/purchase/AssignCreditsToPhysio`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    authorization: `Bearer ${token}`,
                },
                body: JSON.stringify(creditsData),
            });

            StatusCode(response, navigate);
            response = await response.json();
            return response;
        } catch (error) {
            throw new Error(error.message);
        }
    },

    getResellerList: async (token, navigate) => {
        try {
            let response = await fetch(`${ARENO_API_ENDPOINT}/auth/AdminGetResellerList`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    authorization: `Bearer ${token}`,
                },
                body: JSON.stringify({
                    "ReqFields": [
                        "BuisnessName",
                        "ResellerUserID",
                        "Mobile_Number",
                        "Email"
                    ]
                }),
            });

            StatusCode(response, navigate);
            response = await response.json();
            return response;
        } catch (error) {
            throw new Error(error.message);
        }
    },

    getSalesExecutiveList: async (token, navigate, resellerUserID) => {
        try {
            let response = await fetch(`${ARENO_API_ENDPOINT}/auth/AdminGetSalesExecutiveList`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    authorization: `Bearer ${token}`,
                },
                body: JSON.stringify({
                    "ReqFields": [
                        "BuisnessName",
                        "SalesExecutiveUserID",
                        "Mobile_Number",
                        "Email"
                    ],
                    "ResellerUserID": resellerUserID
                }),
            });

            StatusCode(response, navigate);
            response = await response.json();
            return response;
        } catch (error) {
            throw new Error(error.message);
        }
    },

    addDoctorSlotForVideoSession: async (token, navigate, slotData, timeOffSet = 330) => {
        try {
            let response = await fetch(
                `${ARENO_API_ENDPOINT}/conference/adminAddDoctorSlotForVideoSession?lan=en-IN&TimeOffSet=${timeOffSet}`,
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        authorization: `Bearer ${token}`,
                    },
                    body: JSON.stringify(slotData),
                }
            );

            StatusCode(response, navigate);
            response = await response.json();
            return response;
        } catch (error) {
            throw new Error(error.message);
        }
    },

    getDoctorSlotDetails: async (token, navigate, slotData, timeOffSet = 330) => {
        try {
            let response = await fetch(
                `${ARENO_API_ENDPOINT}/conference/AdminGetDoctorSlotDetails?lan=en-IN&TimeOffSet=${timeOffSet}`,
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        authorization: `Bearer ${token}`,
                    },
                    body: JSON.stringify(slotData),
                }
            );

            StatusCode(response, navigate);
            response = await response.json();
            return response;
        } catch (error) {
            throw new Error(error.message);
        }
    },

    deleteDoctorSlots: async (token, navigate, slotData) => {
        try {
            let response = await fetch(
                `${ARENO_API_ENDPOINT}/conference/AdminDeleteDoctorSlots?lan=en-IN`,
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        authorization: `Bearer ${token}`,
                    },
                    body: JSON.stringify(slotData),
                }
            );

            StatusCode(response, navigate);
            response = await response.json();
            return response;
        } catch (error) {
            throw new Error(error.message);
        }
    },

    getVideoSessionList: async (token, navigate) => {
        try {
            let response = await fetch(`${ARENO_API_ENDPOINT}/conference/AdminGetVideoSessionList`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    authorization: `Bearer ${token}`,
                },
                body: JSON.stringify({}),
            });

            StatusCode(response, navigate);
            response = await response.json();
            return response;
        } catch (error) {
            throw new Error(error.message);
        }
    },

    rescheduleVideoSession: async (token, navigate, rescheduleData) => {
        try {
            let response = await fetch(`${ARENO_API_ENDPOINT}/conference/AdminRescheduleVideoSession`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    authorization: `Bearer ${token}`,
                },
                body: JSON.stringify(rescheduleData),
            });

            StatusCode(response, navigate);
            response = await response.json();
            return response;
        } catch (error) {
            throw new Error(error.message);
        }
    },

    getDoctorIdsAndNames: async (token, navigate) => {
        try {
            let response = await fetch(`${ARENO_API_ENDPOINT}/conference/AdminGetDoctorIdsAndNames`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    authorization: `Bearer ${token}`,
                },
                body: JSON.stringify({
                    "IsAvailableForFreeSlotsBooking": true
                }),
            });

            StatusCode(response, navigate);
            response = await response.json();
            return response;
        } catch (error) {
            throw new Error(error.message);
        }
    },
};

export { PhysioServices };
